/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Skip_To_ContentInputs */

const da_common_skip_to_content = /** @type {(inputs: Common_Skip_To_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til indhold`)
};

/** @type {(inputs: Common_Skip_To_ContentInputs) => LocalizedString} */
const en_common_skip_to_content = da_common_skip_to_content;

/**

* @param {Common_Skip_To_ContentInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const common_skip_to_content = /** @type {((inputs?: Common_Skip_To_ContentInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Skip_To_ContentInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_skip_to_content(inputs)
	return /** @type {LocalizedString} */ ("Gå til indhold")
});